module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/close-0566b215ecca0fe722e1889ce2386a46.svg&quot;;"